export default __webpack_public_path__ + "static/media/Deena 9781408362341.0548056e.jpg";